module.exports = __webpack_public_path__ + "img/no-img.a5dd2a1d.png";